import { createApp } from 'vue';
import VueLazyload from 'vue-lazyload';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';

import ProfileSortModels from '../pages/ProfileSortModels.vue';

import PostSortItem from '../components/PostSortItem.vue';
import SortedActionButtons from '../components/SortedActionButtons.vue';
import NavPanel from '../components/NavPanel.vue';
import SearchInput from '../components/SearchInput.vue';
class ProfileSortModelsComponent {
  constructor({ container }) {
    this.app = null;
    this.container = container;
  }
  init() {
    this.app = createApp(ProfileSortModels);
    this.app.use(I18NextVue, { i18next });
    this.app.use(VueLazyload, {
      preLoad: 2.6 // default 1.3
    });

    this.app.component('post-sort-item', PostSortItem);
    this.app.component('sorted-action-buttons', SortedActionButtons);
    this.app.component('nav-panel', NavPanel);
    this.app.component('search-input', SearchInput);
    // Mount the Vue app to the specified container
    this.app.mount(this.container);
  }
}

export default ProfileSortModelsComponent;
